import React from "react";
import { Box, Button, Chip, Skeleton, Typography } from "@mui/material";
import { AddRounded, EditRounded } from "@mui/icons-material";

import { ReactComponent as AddressCard } from "../../../resources/images/svg/home/addressCard.svg";
import { ReactComponent as UserShape } from "../../../resources/images/svg/home/userShape.svg";
import PraticesDialog from "./DialogProfile/PraticesDialog";
import WhenDialog from "./DialogProfile/WhenDialog";
import moment from "moment";
import WebsiteDialog from "./DialogProfile/WebsiteDialog";

const UserSection = ({ user }) => {
  const userInitials = React.useMemo(() => {
    return `${user?.prenom?.charAt(0).toUpperCase()}${user?.nom?.charAt(0).toUpperCase()}`;
  }, [user]);

  const userName = React.useMemo(() => {
    const firstName =
      user?.prenom.charAt(0).toUpperCase() + user?.prenom.substring(1);
    const lastName = user?.nom.charAt(0).toUpperCase() + user?.nom.substring(1);
    return `${firstName ?? "A"} ${lastName ?? "A"}`;
  }, [user]);

  const userNiveau = React.useMemo(() => {
    if(parseInt(user?.niveau) > 0) {
      return parseInt(user?.niveau);
    }
    return 0;
  }, [user]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        marginTop: -2,
      }}
    >
      <Box
        sx={{
          position: "relative",
        }}
      >
        <UserShape />
        <Typography
          variant={"h2"}
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "white",
            padding: 0,
            margin: 0,
          }}
        >
          {userInitials}
        </Typography>
      </Box>
      <Typography
        sx={{
          color: "white",
          fontSize: "32px",
          fontWeight: 900,
          marginTop: -7,
          wordWrap: "no-wrap",
        }}
      >
        {userName}
      </Typography>
      {userNiveau && userNiveau > 2 && (<Button
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 1,
          fontSize: "16px",
          color: (theme) => theme.palette.primary.main,
          textTransform: "none",
        }}
      >
        <AddressCard />
        Voir l'aperçu de ma fiche profil
      </Button>)}
    </Box>
  );
};

const PraticesSection = ({ proInfo, pratices, onOpenDialog, onOpenDialogDate, 
        onOpenDialogSite }) => {  

  const userNiveau = React.useMemo(() => {
    if(parseInt(proInfo?.niveau) > 0) {
      return parseInt(proInfo?.niveau);
    }
    return 0;
  }, [proInfo]);

  const levelColor = React.useMemo(() => {
    if (userNiveau <= 1 || !proInfo) return "#0596A1";
    if (userNiveau === 2) return "#3971F6";
    if (userNiveau >= 3) return "#9A45F4";
  }, [userNiveau]);

  const IconComponent = pratices.length > 0 ? EditRounded : AddRounded;

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          width: "100%",
          marginTop: 3,
        }}
      >

      
        <Typography
          sx={{
            color: "white",
            fontSize: "18px",
            fontWeight: 900,
          }}
        >
          Vos pratiques
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            flexWrap: "wrap",
            marginTop: 2,
            gap: 2,
          }}
        >
          {!proInfo && (
            <>
              <Skeleton
                variant={"rectangular"}
                width={"100px"}
                height={"32px"}
                sx={{ bgcolor: "grey.500", borderRadius: "17px" }}
              />
              <Skeleton
                variant={"rectangular"}
                width={"100px"}
                height={"32px"}
                sx={{ bgcolor: "grey.500", borderRadius: "17px" }}
              />
            </>
          )}
          {pratices?.map((pratice) => {
            return (
              <Chip
                key={pratice.id}
                label={pratice.titre}
                sx={{
                  backgroundColor: levelColor,
                  color: "white",
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
              />
            );
          })}
          {userNiveau && userNiveau < 3 && (<Chip
            onClick={() => {
              onOpenDialog(true);
            }}
            label={
              pratices.length > 0
                ? "Modifier mes pratiques"
                : "Ajouter mes pratiques"
            }
            icon={
              <IconComponent
                sx={{
                  paddingLeft: pratices.length > 0 ? "5px" : undefined,
                  color: "#ffffff !important",
                }}
              />
            }
            variant="outlined"
            sx={{
              color: "white",
              fontWeight: "bold",
              fontSize: "16px",
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "#ffffff22 !important",
              },
            }}
          />)}
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          width: "100%",
          marginTop: 3,
        }}
      >

        <Typography
          sx={{
            color: "white",
            fontSize: "18px",
            fontWeight: 900,
          }}
        >
          Depuis quand exercez-vous ? 
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            flexWrap: "wrap",
            marginTop: 1,
            gap: 2,
          }}
        >
          {!proInfo && (
            <>
              <Skeleton
                variant={"rectangular"}
                width={"100px"}
                height={"32px"}
                sx={{ bgcolor: "grey.500", borderRadius: "17px" }}
              />
            </>
          )}
          {proInfo?.whenBegin && (
              <Typography
                sx={{
                  color: (theme) => theme.palette.primary.main,
                  fontSize: 16,
                  fontWeight: 900,
                }}
              >
                {moment(proInfo?.whenBegin).diff(moment('1995-01-25'), 'years') >= 0 ? moment(proInfo?.whenBegin).format("YYYY") : ''}
              </Typography>
            )}
          <Chip
            onClick={() => {
              onOpenDialogDate(true);
            }}
            label={"Modifier"}
            icon={
              <IconComponent
                sx={{
                  paddingLeft:  "5px",
                  color: "#ffffff !important",
                }}
              />
            }
            variant="outlined"
            sx={{
              color: "white",
              fontWeight: "bold",
              fontSize: "16px",
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "#ffffff22 !important",
              },
            }}
          />
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          width: "100%",
          marginTop: 3,
        }}
      >

        <Typography
          sx={{
            color: "white",
            fontSize: "18px",
            fontWeight: 900,
          }}
        >
          Votre site internet : 
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            flexWrap: "wrap",
            marginTop: 1,
            gap: 2,
          }}
        >
          {!proInfo && (
            <>
              <Skeleton
                variant={"rectangular"}
                width={"100px"}
                height={"32px"}
                sx={{ bgcolor: "grey.500", borderRadius: "17px" }}
              />
            </>
          )}
          {proInfo?.website && (
              <Typography
                sx={{
                  color: (theme) => theme.palette.primary.main,
                  fontSize: 16,
                  fontWeight: 900,
                }}
              >
                {proInfo?.website}
              </Typography>
            )}
          <Chip
            onClick={() => {
              onOpenDialogSite(true);
            }}
            label={"Modifier"}
            icon={
              <IconComponent
                sx={{
                  paddingLeft:  "5px",
                  color: "#ffffff !important",
                }}
              />
            }
            variant="outlined"
            sx={{
              color: "white",
              fontWeight: "bold",
              fontSize: "16px",
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "#ffffff22 !important",
              },
            }}
          />
        </Box>
      </Box>
    </>
  );
};

const ProfileSection = ({ proInfo, user, refetch }) => {
  const [open, setOpen] = React.useState(false);
  const [openDate, setOpenDate] = React.useState(false);
  const [openSite, setOpenSite] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
    refetch();
  };

  const handleCloseDate = () => {
    setOpenDate(false);
    refetch();
  };

  const handleCloseSite = () => {
    setOpenSite(false);
    refetch();
  };

  const pratices = React.useMemo(() => {
    let tmp = [];
    try {
      const tmp2 = JSON.parse(proInfo?.jsonPratiques);
      tmp = Array.isArray(tmp2) ? tmp2 : [];
    } catch (e) {
      tmp = [];
    }
    return tmp;
  }, [proInfo]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        width: "100%",
        height: "100%",
      }}
    >
      <UserSection user={user} />
      <PraticesSection
        proInfo={proInfo}
        pratices={pratices}
        onOpenDialog={setOpen}
        onOpenDialogDate={setOpenDate}
        onOpenDialogSite={setOpenSite}
      />
      {open && (
        <PraticesDialog open={open} pratices={pratices} onClose={handleClose} />
      )}
      {openDate && (
        <WhenDialog open={setOpenDate} whenBegin={proInfo?.whenBegin} onClose={handleCloseDate} />
      )}
      {openSite && (
        <WebsiteDialog open={setOpenSite} website={proInfo?.website} onClose={handleCloseSite} />
      )}
    </Box>
  );
};

export default ProfileSection;
